import { isValidPhoneNumber } from 'libphonenumber-js';

export const mobileFormatStrategy = (value: string) => {
  return isValidPhoneNumber(value, 'TW');
};
